import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cee544ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold mb-4" }, "Text Utility", -1))
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "String Length:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Word Count:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Toggled Text:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputText) = $event)),
        class: "w-full h-32 p-3 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50",
        placeholder: "Enter your text here"
      }, null, 512), [
        [_vModelText, _ctx.inputText]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCase && _ctx.toggleCase(...args))),
        class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      }, " Toggle Case ")
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("p", null, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.stringLength), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.wordCount), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.toggledText), 1)
      ])
    ])
  ]))
}